import { render, staticRenderFns } from "./topBigPic.vue?vue&type=template&id=3a26ae71&scoped=true&"
import script from "./topBigPic.vue?vue&type=script&lang=js&"
export * from "./topBigPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a26ae71",
  null
  
)

export default component.exports